<template>
  <div class="sys_all">


    <div class="sys_header">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="功能区 " name="first"></el-tab-pane>
        <el-tab-pane label="养殖管理 " name="second"></el-tab-pane>
        <el-tab-pane label="嘉农物联 " name="three"></el-tab-pane>
        <el-tab-pane label="供应链管理 " name="four"></el-tab-pane>
        <el-tab-pane label="CRM系统 " name="five"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 功能区 -->
    <div class="sys_function" v-if="activeName == 'first'">
      <div class="sys_function_content">
        <div class="sys_function_img" @click="changeNav('second')">
          <img :src="yzgl" alt="">
        </div>
        <div class="sys_function_font">养殖管理系统</div>
      </div>
      <div class="sys_function_content">
        <div class="sys_function_img"  @click="changeNav('three')">
          <img :src="nqwl" alt="">
        </div>
        <div class="sys_function_font">嘉农物联</div>
      </div>
      <div class="sys_function_content">
        <div class="sys_function_img"  @click="changeNav('four')">
          <img :src="gylgl" alt="">
        </div>
        <div class="sys_function_font">供应链管理</div>
      </div>
      <div class="sys_function_content">
        <div class="sys_function_img"  @click="changeNav('five')">
          <img :src="crm" alt="">
        </div>
        <div class="sys_function_font">CRM系统</div>
      </div>
    </div>


    <!-- 养殖管理 -->
    <div class="sys_cultivation" v-if="activeName == 'second'">
      <div class="sys_cultivation_no" v-if="breed == 0">
        <div class="sys_cultivation_no_img">
          <img :src="gantan" alt="">
        </div>
        <div class="sys_cultivation_no_font">您还没有购买系统，请点击上面<span>"系统管理"</span>进行购买!</div>
      </div>

      <div class="sys_cultivation_into" v-else  @click="changeNav('first')">
        <img :src="into" alt="">
      </div>

    </div>

    <!-- 嘉农物联 -->
    <div v-if="activeName == 'three'" class="system_other"></div>

    <!-- 供应链管理 -->
    <div v-if="activeName == 'four'" class="system_other"></div>

    <!-- CRM系统 -->
    <div v-if="activeName == 'five'" class="system_other"></div>

  </div>
</template>

<script>
export default {
  name: "System",
  data() {
    return {
      activeName: "first",
      isYZ : false,
      crm: "./static/img/CRM.png",
      yzgl: "./static/img/yzgl.png",
      nqwl: "./static/img/nqwl.png",
      gylgl: "./static/img/gylgl.png",
      gantan: "./static/img/!.png",
      into: "./static/img/into.png",
      breed : ""
    };
  },
  mounted() {
    this.$store.commit("setNavLeft", 0);
    this.breed = localStorage.getItem("breed");
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
    changeNav(e){
      if(e == 'second'){
        if(this.breed == 0){
          this.$message.error("您还未购买养殖管理系统");
        }else{
          window.open('http://breedh5.danjiguanjia.com/login?ticket=' + localStorage.getItem("ticket"));//正式
          // window.open('http://breedh5.test.jianong.com/login?ticket=' + localStorage.getItem("ticket"));//测试
        }
        
      }else{
        this.activeName = e
      }
    }
  }
};
</script>

<style>
.sys_header{
  width: 974px;
}
.sys_header .el-tabs__item{
  font-size: 26px;
  margin-bottom: 10px;
  color: #636363;
}
.sys_header .el-tabs__item.is-active {
  color: #55B233;
}
.sys_header .el-tabs__active-bar {
  background-color: #55B233;
}
.sys_header .el-tabs__item:hover{
  color: #55B233 !important;
}
.sys_function{
  display: flex;
  width: 974px;
  height: 621px;
  margin-top: 20px;
  background: #ffffff;
}
.sys_function_content{
  margin-left: 50px;
  margin-top: 86px;
  cursor: pointer;
}
.sys_function_content:first-child{
  margin-left: 87px;
}
.sys_function_img{
  width: 160px;
  height: 160px;
  /* background: cornflowerblue; */
}
.sys_function_img img{
  width: 100%;
  height: 100%;
}
.sys_function_font{
  font-size: 22px;
  color: #515151;
  text-align: center;
  margin-top: 21px;
}
.sys_cultivation{
  width: 974px;
  height: 621px;
  background: #ffffff;
}
.sys_cultivation_no{
  display: flex;
  padding-top: 147px;
  margin-left: 122px;
}
.sys_cultivation_no_img{
  width: 69px;
  height: 69px;
}
.sys_cultivation_no_img img {
  width: 100%;
  height: 100%;
}
.sys_cultivation_no_font{
  height: 69px;
  line-height: 69px;
  margin-left: 30px;
  font-size: 26px;
  color: #C4C4C4;
}
.sys_cultivation_no_font span{
  color: #55B233;
}
.sys_cultivation_into{
  height: 46px;
  width: 300px;
  float: right;
  margin-top: 21px;
  margin-right: 14px;
}
.sys_cultivation_into img{
  width: 100%;
  height: 100%;
}
.system_other{
  width: 100%;
  height: 640px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/my/System.vue